module.exports = __webpack_public_path__ + "media/images/icons/file_attach-b83b06536a0cdedc1b325f549f3c5710.svg";